import Presentation from "./presentation";

const ActionButton = ( { onClick, isActive, activeIconName, iconName, title } ) => {
	return (
		<Presentation
			activeIconName = { activeIconName }
			iconName       = { iconName }
			isActive       = { isActive }
			onClick        = { onClick }
			title          = { title }
		/>
	);
};

export default ActionButton;